import {Banner} from '@/components/Banner';
import {Button} from '@/components/ui/button';
import {useConsentStore} from '@/store/consent';

/**
 * Cookie consent banner displayed at the top of the page.
 * Informs users about essential cookie usage as required by PDPA.
 * Only shown until user acknowledges.
 */
export function ConsentBanner() {
  const {hasResponded, acknowledge, _hasHydrated} = useConsentStore();

  // Don't render until store has hydrated from cookies
  if (!_hasHydrated) return null;

  // Hide banner once user has responded
  if (hasResponded) return null;

  return (
    <Banner position="top" actions={<Button onClick={acknowledge}>I Understand</Button>}>
      <p>
        We use essential cookies for authentication and platform functionality. Learn more in our{' '}
        <a
          href="/privacy-policy"
          className="font-medium text-foreground underline underline-offset-4 hover:text-primary"
        >
          Privacy Policy
        </a>
        .
      </p>
    </Banner>
  );
}
